import React from 'react'

import { gettext } from '../../../../services'

const t = {
    COUNT_TEXT: gettext('{first} - {last} of {count} routes'),
    SHORT_COUNT_TEXT: gettext('{count} routes'),
}

/**
 * Search app header.
 * @param {Object} props
 * @param {number} props.total Total number of search results
 * @param {number} props.first Number of the first result on current page
 * @param {number} props.last Number of the last result on current page
 */
const ResultsCount = ({ total, first, last }) => {
    const countText = t.COUNT_TEXT
        .replace('{first}', '' + first)
        .replace('{last}', '' + last)
        .replace('{count}', '' + total)

    const shortCountText = t.SHORT_COUNT_TEXT
        .replace('{count}', '' + total)

    return (
        <strong className="text-secondary">
            {total > last ? (
                <>
                    <span className="visible-xs">{shortCountText}</span>
                    <span className="hidden-xs">{countText}</span>
                </>
            ) : shortCountText}
        </strong>
    )
}

export default ResultsCount
